<template>
  <a
    v-if="visible"
    class="iconfont icon-telephone"
    href="javascript:;"
    @click="openCallDialog"
  ></a>
</template>

<script>
export default {
  props: {
    // employee.em_id
    emId: Number,
    // account.id
    accountId: Number,
    mobile: String,
  },
  computed: {
    visible() {
      var me = this;
      return me.isMobile && (me.emId || me.accountId || me.mobile);
    },
    isMobile() {
      var ua = navigator.userAgent.toLowerCase();
      return (
        ua.indexOf("mobile") !== -1 ||
        ua.indexOf("iphone") !== -1 ||
        ua.indexOf("android") !== -1 ||
        ua.indexOf("linux") !== -1
      );
    },
  },
  methods: {
    openCallDialog() {
      var me = this;
      if (me.mobile) {
        me.callMobile(me.mobile);
      } else if (me.emId) {
        me.callMobileByEmployee(me.emId);
      } else if (me.accountId) {
        me.callMobileByAccount(me.accountId);
      }
    },
    /**
     * 查找employee接口返回手机号，再唤起拨打
     */
    callMobileByEmployee(em_id) {
      var me = this;
      me.$ajax({
        url: "/api/document/employee/read/" + em_id,
      })
        .then(function (res) {
          if (res.success) {
            var data = res.data;
            if (data && data.main && data.main.em_mobile) {
              me.callMobile(data.main.em_mobile);
            } else {
              me.$weui.topTips("未设置手机号", 3000);
            }
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        })
        .catch(function (e) {
          me.$weui.topTips(e.message, 3000);
        });
    },
    /**
     * 查找account接口返回手机号，再唤起拨打
     */
    callMobileByAccount(accountId) {
      var me = this;
      me.$ajax({
        url: "/api/account/account/read/" + accountId,
      })
        .then(function (res) {
          if (res.success) {
            var data = res.data;
            if (data && data.mobile) {
              me.callMobile(data.mobile);
            } else {
              me.$weui.topTips("未设置手机号", 3000);
            }
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        })
        .catch(function (e) {
          me.$weui.topTips(e.message, 3000);
        });
    },
    /**
     * 唤起拨打
     * @param {*} mobile
     */
    callMobile(mobile) {
      var link = document.createElement("a");
      link.setAttribute("href", "tel:" + mobile);
      link.click();
    },
  },
};
</script>